import React from "react";

import "./desktop-offers-style.scss";
import useIsComDomain from "@src/hooks/useIsComDomain";

import OfferList from "@src/componentsNew/Offers/OfferList";
import { uiComponentVariables } from "@src/core/config";

const DesktopOffersPage = () => {
  const isComDomain = useIsComDomain();

  return (
    <div id="desktop-offers-wrapper">
      <OfferList isFindMoreOffers={false} uiComponentVariable={isComDomain ? uiComponentVariables.mainOffersCom : uiComponentVariables.mainOffers} />
    </div>
  )
};

export default DesktopOffersPage;
